import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Scrollbar } from "swiper/modules";
import { setCartItem } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { openCart } from "../../redux/slices/uiSlice";
import ProductCard from "./ProductCard";

const PreviouslyViewed = () => {
  const dispatch  = useDispatch();
  const products  = useSelector((s) => s.viewedProducts.products);
  const cartItems = useSelector((s) => s.cart.cartItems);

  if (!products?.length) return null;

  const addItemToCart = (product) => {
    const existing = cartItems.find((i) => i.product === product._id);
    if (existing && existing.quantity >= product.stock) {
      toast.error("Maximum items already added");
      return;
    }
    dispatch(setCartItem({
      product:  product?._id,
      name:     product?.name,
      price:    product?.price,
      image:    product?.images[0]?.url,
      stock:    product?.stock,
      quantity: existing ? existing.quantity + 1 : 1,
    }));
    dispatch(openCart());
    toast.success(existing ? "Quantity updated" : "Added to bag");
  };

  return (
    <section aria-label="Recently viewed products">

      {/* Heading — matches PDP/Home section label style */}
      <p className="font-sourcesans text-xs font-medium tracking-widest uppercase text-stone-400 mb-5">
        Recently Viewed
      </p>

      {/* overflow-hidden wrapper prevents horizontal page scroll on mobile */}
      <div className="overflow-hidden">
        <Swiper
          modules={[Autoplay, Scrollbar]}
          breakpoints={{
            0:   { slidesPerView: 1.2,  spaceBetween: 10 },
            375: { slidesPerView: 1.85, spaceBetween: 12 },
            640: { slidesPerView: 2.4,  spaceBetween: 14 },
            768: { slidesPerView: 3,    spaceBetween: 16 },
            1024:{ slidesPerView: 4,    spaceBetween: 20 },
          }}
          autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          scrollbar={{ hide: false, draggable: true }}
          className="w-full !overflow-visible"
        >
          {products.map((product) => (
            <SwiperSlide key={product._id}>
              <ProductCard product={product} addItemToCart={addItemToCart} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default PreviouslyViewed;